import React from 'react';
import Layout from './Layout/Layout';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
